import { type PolymorphicComponent } from '@mui/base'

import { IconArrowRight } from '@redteclab/icons'

import { Button, type ButtonProps, type ButtonTypeMap } from 'base-ui'

export const ContactPageFlatCta: PolymorphicComponent<ButtonTypeMap> = (
  props: ButtonProps,
) => {
  const { children, onClick, startIcon, ...other } = props

  return (
    <Button
      className="w-full justify-between rounded-xl bg-light-brand-medium px-4 py-6"
      endIcon={<IconArrowRight className="fill-dark-brand" />}
      onClick={onClick}
      startIcon={startIcon}
      variant="text"
      {...other}
    >
      {children}
    </Button>
  )
}
